// eslint-disable-next-line import/prefer-default-export
export function isResponse(obj): obj is FetchResponse {
  return 'response' in obj;
}

export function isPromise(f): f is Promise<any> {
  if (
    f !== null
    && typeof f === 'object'
    && typeof f.then === 'function'
    && typeof f.catch === 'function'
  ) {
    return true;
  }

  return false;
}
